<template>
  <v-container grid-list-md class="pa-0 pt-4">
    <v-form>
      <v-row dense align="center">
        <v-col cols="6" sm="2">
          <v-select v-model="form.author"
            label="顧客担当者"
            :items="getConsultantItems"
            item-text="name"
            item-value="userid"
            @change="search(1)"
          />
        </v-col>
        <v-col cols="6" sm="2">
          <v-select v-model="form.arranger"
            label="手配担当者"
            :items="getArrangerItems"
            item-text="name"
            item-value="userid"
          />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="2">
          <v-switch v-model="form.status"
            color="secondary"
            :label="printFormStatus"
            @change="search(1)"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-divider></v-divider>
    <v-row dense justify="end">
      <v-col sm="2" class="pt-4">
        <span class="body-2 text-xs-center">{{ printPageInfo }}</span>
      </v-col>
      <v-col sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" color="secondary" :disabled="isLoading || !isAccessiblePrev" @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" color="secondary" :disabled="isLoading || !isAccessibleNext" @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
  </v-container>
</template>

<script>
const DEF = {
  LIMIT: '20',
  PAGENUMBER: 1
}
export default {
  name: 'authorStaysToolbars',
  props: [
    'status'
  ],
  data () {
    return {
      form: {
        author: '',
        arranger: '',
        status: false,
        limit: DEF.LIMIT,
        page: DEF.PAGENUMBER,
        size: 0
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.search()
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$nextTick(() => {
          let fm = this.getForm(page)
          this.$emit('emit', {
            action: 'get',
            data: fm
          })
        })
      }
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.search(num - 1)
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.search(num + 1)
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    getForm: function (page) {
      return {
        author: this.form.author,
        arranger: this.form.arranger,
        status: this.form.status ? 'done' : 'active',
        limit: {
          offset: (page != null && Number.isFinite(page)) ? page : this.form.page,
          size: this.form.limit
        },
        page: (page != null && Number.isFinite(page)) ? page : this.form.page
      }
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    getConsultantItems () {
      let authors = this.$store.getters['config/get']('authors')
      return [{
        userid: '',
        name: '選択なし'
      }].concat(Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('consultant')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      }))
    },
    getArrangerItems () {
      let authors = this.$store.getters['config/get']('authors')
      return [{
        userid: '',
        name: '選択なし'
      }].concat(Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('arranger')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      }))
    },
    printFormStatus () {
      return this.form.status ? '完了' : '未完'
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return st + ' - ' + ed + ' / ' + this.form.size
    }
  }
}
</script>
